/* eslint-disable */
import React, { useMemo } from 'react'
import { Route, Switch, BrowserRouter, Redirect } from 'react-router-dom'
import CssBaseline from '@mui/material/CssBaseline'
import { ThemeProvider } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'

import theme from './theme'
import Home from './apps/home'
import TeamList from './apps/team/components/TeamList'
import AboutUs from './apps/about/components/AboutUs'
import TechStack from './apps/tech/components/TechStack'
import AIPage from './apps/ai/components/AIPage'
import OpenSource from './apps/open/components/OpenSource'

import { ScreenContext } from './apps/utils/ScreenContext'


export const routes = [
	{ id: 0, path: '/' },
	{ id: 2, path: '/team' },
	{ id: 3, path: '/act' },
	{ id: 4, path: '/tech-stack' },
	{ id: 5, path: '/ai' },
	{ id: 6, path: '/open-source' },
]

export default function App() {
	const isTablet = useMediaQuery('(min-width: 768px)')
	const isLaptop = useMediaQuery('(min-width: 1024px)')
	const isMedium = useMediaQuery('(min-width: 1375px)')
	const isLandscape = useMediaQuery('(min-width: 1440px)')
	const isLargeScreen = useMediaQuery('(min-width: 1700px)')

	const contextValue = useMemo( () => {
		return ({
			isTablet, isLaptop, isMedium, isLandscape, isLargeScreen
		})
	}, [ isTablet, isLaptop, isMedium ])

	return (
		<ScreenContext.Provider value={ contextValue }>
			<ThemeProvider theme={ theme }>
				<CssBaseline />
				<BrowserRouter>
					<Switch>
						<Route exact path='/' component={ Home } />
						<Route path='/team' component={ TeamList } />
						<Route path='/act' component={ AboutUs } />
						<Route path='/ai' component={ AIPage } />
						<Route path='/open-source' component={ OpenSource } />
						<Redirect from='/about-us' to='/act' />
						<Route path='/tech-stack' component={ TechStack } />
					</Switch>
				</BrowserRouter>
			</ThemeProvider>
		</ScreenContext.Provider>
	)
}
